<p-table
	#pTable
	[paginatorDropdownAppendTo]="'body'"
	[columns]="columns"
	[value]="data"
	[paginator]="pagination"
	[rows]="pageSize"
	[totalRecords]="total"
	[lazy]="isLazy"
	(onLazyLoad)="loadLazy($event)"
	[rowsPerPageOptions]="rowsPerPage"
	[customSort]="false"
	dataKey="id"
	[reorderableColumns]="true"
	[styleClass]="'table-theme'"
	[resizableColumns]="true"
	[scrollable]="scrollable"
	[scrollHeight]="scrollHeight">
	@if (title) {
		<ng-template #caption>
			<div class="ui-helper-clearfix">
				<div class="ui-g">
					<div class="ui-lg-6 ui-md-6 ui-g-12 text-left flex align-items-center" style="color: #fff">
						{{ title }}
						@if (switchValue !== null) {
							<span style="color: white; font-weight: 200; font-size: 12px; margin: 8px; padding-left: 8px">
								{{ switchButtonLabel | translate }}
							</span>
						}
						@if (switchValue !== null) {
							<p-toggleswitch
								[ngStyle]="{ 'margin-top': '5px' }"
								[disabled]="false"
								[(ngModel)]="switchValue"
								(onChange)="onChangeSwitch(id)"></p-toggleswitch>
						}
					</div>
					<div class="ui-lg-6 ui-md-6 ui-g-12 text-right"></div>
				</div>
			</div>
		</ng-template>
	}

	<ng-template #header let-columns>
		<tr>
			@for (col of columns; track col) {
				<th [style.min-width]="columnWidth" pResizableColumn>
					{{ col.header }}
				</th>
			}
			@if (actionButtons?.length) {
				<th [style.min-width]="columnWidth">
					{{ 'action' | translate }}
				</th>
			}
		</tr>
	</ng-template>
	<ng-template #body let-rowData let-columns="columns">
		<tr>
			@for (col of columns; track col) {
				<td class="ui-resizable-column" [style.min-width]="columnWidth">
					<sis-col-value [col]="col" [rowData]="rowData"></sis-col-value>
				</td>
			}
			@if (actionButtons?.length) {
				<td [style.min-width]="columnWidth">
					@for (btn of actionButtons; track btn) {
						<button
							type="button"
							pButton
							(click)="invokeAction(btn.id, rowData)"
							class="ui-green-button"
							[label]="btn.label"
							[disabled]="btn?.disabled && btn.disabled(rowData)"></button>
					}
				</td>
			}
		</tr>
	</ng-template>

	<ng-template #emptymessage>
		<tr>
			<td [attr.colspan]="columns.length" class="bold text-center">
				{{ 'thereIsNoDataToDisplay' | translate }}
			</td>
		</tr>
	</ng-template>
</p-table>
